import { render, staticRenderFns } from "./group-edit.vue?vue&type=template&id=235733b4&scoped=true&"
import script from "./group-edit.vue?vue&type=script&lang=ts&"
export * from "./group-edit.vue?vue&type=script&lang=ts&"
import style0 from "./group-edit.vue?vue&type=style&index=0&id=235733b4&prod&lang=scss&scoped=true&"
import style1 from "./group-edit.vue?vue&type=style&index=1&id=235733b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235733b4",
  null
  
)

export default component.exports